skrilla.controller('exportToCsvModalCtrl', function ($scope, cacheService, $timeout) {

    $scope.headers = [];
    $scope.data = cacheService.getObject("exportToCsv");
    $scope.filename = ""
});
